export const mandateStatuses = [
  'AUTHORIZATION_REQUIRED',
  'AUTHORIZING',
  'PROCESSING',
  'SUBMITTED',
  'SUCCEEDED',
  'FAILED',
  'READY_TO_SUBMIT',
  'CLOSED',
  'CANCELLED',
];

export const cardStatuses = ['CREATED', 'PROCESSING', 'SUCCEEDED', 'FAILED', 'CANCELLED'];

export const paymentMethodStatuses = Array.from(new Set([...mandateStatuses, ...cardStatuses]));
